import { FORMAT_C3_YEAR_DATE } from '@cube3/common/model/schema/resources/metadata-field';
import moment from 'moment';
import { FieldType } from '../types/GenericFormTypes';

const emptyArray = []

const identityFormatter = (val) => val;
const numberFormatter = (val) => (val ? String(val) : '');
const stringFormatter = (val) => (val ? String(val) : '');
const yearFormatter = (val) =>
  val &&
  moment(val)
    .utc()
    // prevent issues with timezones
    .endOf('day')
    .toISOString();

const waterfallSelectFormatter = (val) => {
  return val
    ? {
      input: {
        level1: val?.value ? Object.keys(val?.value)[0] : undefined,
        level2: val?.value
          ? val?.value[Object.keys(val?.value)[0]]
          : undefined
      }
    }
    : undefined;
};

export const multiSelectFormatter = (val: string[] = emptyArray) => {
  const arr = !Array.isArray(val) ? emptyArray : val;
  return arr.map((v) => ({ id: v?.id || v, value: v?.value || v }));
};
const recipientsFormatter = (val: string[] = emptyArray) => {
  const arr =
    typeof val === 'string'
      ? (val as string).split(',')
      : !Array.isArray(val)
        ? emptyArray
        : val;
  return arr.map((v) => ({ email_address: v }));
};

const checkboxFormatter = (val: boolean) => {
  return val ?? false
}

const checkboxMultipleFormatter = (val: string[]) => {
  return val ?? emptyArray
}

/** NOTE: FieldArray type fields don't support format */
export const makeFormatter = (fieldType: FieldType, schema) => {
  const type = fieldType;

  switch (type) {
    case 'checkbox':
      if (schema && JSON.parse(schema)?.type === 'boolean') {
        return checkboxFormatter

      } else {
        return checkboxMultipleFormatter
      }
    case 'number':
      return numberFormatter;
    case 'date':
      if (schema && JSON.parse(schema)?.format === FORMAT_C3_YEAR_DATE) {
        return yearFormatter;
      }
      return stringFormatter;
    case 'string':
    case 'email':
    case 'textarea':
      return stringFormatter;
    case 'waterfall_select':
      return waterfallSelectFormatter;
    case 'multiselect':
      return multiSelectFormatter;
    case 'recipients':
      return recipientsFormatter;
    default:
      return identityFormatter;
  }
};
